import React from 'react';
import CheckAgingContainer from '../../components/modules/Reports/CheckAging/CheckAgingContainer';

const CheckAging = () => {
  return <CheckAgingContainer />;
};

export default CheckAging;
